import { UiCenter } from "~/components/elements";
import React from "react";
import { CenterProps } from "@chakra-ui/react";

interface Props extends CenterProps {
  children: React.ReactNode;
}
export function DashboardMainBox({ children, ...rest }: Props) {
  return (
    <UiCenter
      flexDirection="column"
      maxW="67.5rem"
      minH={{ base: "80vh", md: "41rem" }}
      w="full"
      bgColor="#FFFFFF80"
      rounded="3xl"
      overflowY="auto"
      py={{ base: 6, md: 10 }}
      px={{ base: 4, md: 10 }}
      alignSelf="stretch"
      {...rest}
    >
      {children}
    </UiCenter>
  );
}
